import { GridColumnType } from '@grid'
import dayjs from 'dayjs'

const formatMoney = (currency: string, value: number): string =>
	currency === 'KRW'
		? `₩${Math.round(value).toLocaleString('ko-KR')}`
		: `$${Number(value).toLocaleString('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
		  })}`

/** 거래처가 보는 자기 주문 상태 — 백오피스 칩과 같은 색, 말은 영어 */
export const WHOLESALE_STATUS_TITLE: { [key: string]: string } = {
	awaitingPayment: 'Awaiting payment',
	new: 'Paid',
	preparing: 'Preparing',
	inTransit: 'In transit',
	completed: 'Delivered',
	refunded: 'Refunded',
	deleted: 'Cancelled',
}

/**
 * `/customer/wholesale` 하단 목록 — /main/order 의 Grid 를 그대로 쓰되 열은 영어, 편집 없음
 * (DISPATCH_PLAN §5 · PARTNER_PLAN §3.2). 금액은 주문 통화.
 */
export const wholesaleOrderColumns: GridColumnType = {
	initRow: {},
	fieldToFocus: 'id',
	card: {
		title: 'id',
		status: 'status',
		meta: ['createdAt', 'totalAmount', 'paidAt', 'deliveryCompletedAt'],
	},
	columns: [
		{
			field: 'status',
			headerName: 'Status',
			width: 150,
			editable: false,
			headerAlign: 'center',
			align: 'center',
		},
		{ field: 'id', headerName: 'Order no.', width: 220, editable: false },
		{
			field: 'createdAt',
			headerName: 'Placed',
			width: 150,
			editable: false,
			valueFormatter: (value: string) =>
				value ? dayjs(value).format('YYYY-MM-DD HH:mm') : '',
		},
		{
			field: 'items',
			headerName: 'Items',
			width: 260,
			editable: false,
			valueGetter: (_value: unknown, row: any) =>
				(row.detailList ?? [])
					.map((d: any) => `${d.productName} ×${d.quantity}`)
					.join(' · '),
		},
		{
			field: 'totalAmount',
			headerName: 'Subtotal',
			width: 130,
			editable: false,
			align: 'right',
			headerAlign: 'right',
			valueFormatter: (value: number, row: any) => formatMoney(row.currency, value),
		},
		{
			field: 'vatAmount',
			headerName: 'VAT',
			width: 110,
			editable: false,
			align: 'right',
			headerAlign: 'right',
			valueFormatter: (value: number, row: any) =>
				value > 0 ? formatMoney(row.currency, value) : '—',
		},
		{
			field: 'shippingAmount',
			headerName: 'Shipping',
			width: 110,
			editable: false,
			align: 'right',
			headerAlign: 'right',
			valueFormatter: (value: number, row: any) =>
				value > 0 ? formatMoney(row.currency, value) : '—',
		},
		{
			field: 'paidAmount',
			headerName: 'Total',
			width: 140,
			editable: false,
			align: 'right',
			headerAlign: 'right',
			valueFormatter: (value: number, row: any) => formatMoney(row.currency, value),
		},
		{
			field: 'currency',
			headerName: 'Currency',
			width: 90,
			editable: false,
			align: 'center',
			headerAlign: 'center',
		},
		{
			field: 'paidAt',
			headerName: 'Paid',
			width: 130,
			editable: false,
			valueFormatter: (value: string) =>
				value ? dayjs(value).format('YYYY-MM-DD') : '—',
		},
		{ field: 'deliveryCompany', headerName: 'Carrier', width: 110, editable: false },
		{ field: 'trackingNumber', headerName: 'Tracking', width: 170, editable: false },
		{
			field: 'deliveryCompletedAt',
			headerName: 'Delivered',
			width: 130,
			editable: false,
			valueFormatter: (value: string) =>
				value ? dayjs(value).format('YYYY-MM-DD') : '—',
		},
	],
}
